import React, { useState, useEffect } from "react";
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";


const Punjab = () => {
  const [packages, setPackages] = useState([]);
  const [stripe, setStripe] = useState(null);

  useEffect(() => {
    // Load Stripe.js when the component mounts
    const stripePromise = loadStripe("pk_test_51NYCQeKoX4yf2BcDWx5A0S7Q6fbIUGmnbAQgVgqpKfFOZJeVG6gIByZbLXFmzinA9NwSPYsTSI1qTbsnc52l40s400toXeA94r"); // Replace with your Stripe publishable key
    stripePromise.then((stripe) => {
      setStripe(stripe);
    });

    axios
      .get("https://journey-scape-main.vercel.app/api/auth/packages", {
        params: {
          province: "Punjab" // Use the correct field name for province
        }
      })
      .then((response) => {
        setPackages(response.data);
      })
      .catch((error) => {
        console.error("Error fetching tour packages:", error);
      });
  }, []);

  const handleBookNow = async (pkg) => {
    try {
      if (!stripe) {
        console.error("Stripe.js has not been loaded yet.");
        return;
      }
  
      const price = parseFloat(pkg.price.replace(/,/g, '')); // Convert the price string to a number
  
      const response = await axios.post(
        "https://stripe-backend-delta.vercel.app/create-checkout-session",
        {
          title: pkg.title,
          price: price, // Use the numeric price
          images: [pkg.image], // Pass the image URL as an array
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
      const { id } = response.data;
  
      // Redirect to Stripe Checkout
      const result = await stripe.redirectToCheckout({
        sessionId: id,
      });
  
      if (result.error) {
        console.error("Error redirecting to Checkout:", result.error);
      }
    } catch (error) {
      console.error("Error creating checkout session:", error);
    }
  };
  
  return (
    <>
      <Header />
      <main id="content" className="site-main">
        <section className="inner-banner-wrap">
          {/* Inner Banner html start*/}
          <section className="inner-banner-wrap">
            <div
              className="inner-baner-container"
              style={{
                backgroundImage:
                  "url(https://res.cloudinary.com/dvop4v8kb/image/upload/c_fill,e_improve,w_1920,h_800/v1686503409/JheelSaifUlMalook_kwpego.jpg)"
              }}
            >
              <div className="container">
                <div className="inner-banner-content">
                  <h1 className="inner-title">Punjab Packages</h1>
                </div>
              </div>
            </div>
            <div className="inner-shape" />
          </section>
          {/* Inner Banner html end*/}
        </section>

        <div className="package-section">
          <div className="container">
            <div className="package-inner">
              <div className="row">
              {packages
                .filter((pkg) => pkg.province === "Punjab") // Filter packages for Punjab province
                .map((pkg) => (
                  <div key={pkg._id} className="col-lg-4 col-md-6">
                    <div className="package-wrap">
                      <figure className="feature-image">
                        <a href="tel:03084534190">
                        <img src={`https://journey-scape-main.vercel.app/uploads/${pkg.image}`} alt={pkg.title} />
                        </a>
                      </figure>
                      <div className="package-price">
                        <h6>
                          <span>${pkg.price}</span> / per person
                        </h6>
                      </div>
                      <div className="package-content-wrap">
                        <div className="package-meta text-center">
                          <ul>

                            <li>
                              <i className="far fa-clock" />
                              {pkg.duration}
                            </li>
                            <li>
                              <i className="fas fa-user-friends" />
                              People: {pkg.people}
                            </li>
                            <li>
                              <i className="fas fa-map-marker-alt" />
                              {pkg.location}
                            </li>
                          </ul>
                        </div>
                        <div className="package-content">
                          <h3>
                            <a href="tel:03084534190">{pkg.title}</a>
                          </h3>
                          <div className="review-area">
                            <span className="review-text">
                              ({pkg.reviews} reviews)
                            </span>
                            <div
                              className="rating-start"
                              title={`Rated ${pkg.rating} out of 5`}
                            >
                              {/* Your rating styles */}
                            </div>
                          </div>
                          <p>{pkg.description}</p>
                          <div className="btn-wrap">
                            {/* Your rating styles 
                          <button
                              onClick={() => handleBookNow(pkg)}
                              className="button-text width-6"
                            >
                              Book Now
                              
                            </button>
                          
                          */}
                            <Link
                              to={{
                                pathname: `/package/${pkg._id}`,
                                state: { packageData: pkg },
                              }}
                              className="button-text width-6"
                            >
                              Package Detail
                              
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Punjab;
